// extracted by mini-css-extract-plugin
export var about = "about-module--about--H9dbg";